import styled from 'styled-components';

import { DeleteIcon } from 'static';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 19px;
  height: calc(100svh - 151px);
  overflow-y: scroll;
  overflow-x: visible;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-around !important;
  width: 100%;
`;

export const StyledIcon = styled(DeleteIcon)`
  margin-right: 10px;
`;

export const StyledGroupsList = styled.div`
  margin-top: 15px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledGroupItem = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 175px;
  align-items: center;
  column-gap: 12px;
`;

export const StyledGroupName = styled.p`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;
